<div class="flexBox">
    <div>
        <div class="member-validation__header">DOB is Present / Valid</div>
        <app-member-validation-yes-no [isChaseEnabled]=isChaseEnabled textNegative1="No, DOB Missing" textNegative2="No, DOB Incorrect" (onSelect)="onMemberValidationSelection($event)"  (onSelect2)="onMemberValidationSelection($event)"></app-member-validation-yes-no>
    </div>
    <div *ngIf="showMedicalRecord" class="medical-record">
        <member-medical-record-dob-v2></member-medical-record-dob-v2>
    </div>
</div>
